import React from 'react';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { cn } from '@/lib/utils';

export type CalendarProps = React.ComponentProps<typeof DayPicker>;

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('w-full mx-auto', className)}
      classNames={{
        root: 'rdp-root',
        months: 'rdp-months',
        month: 'rdp-month',
        month_caption: 'rdp-caption',
        caption_label: 'rdp-caption_label',
        button_previous: 'rdp-button_previous',
        button_next: 'rdp-button_next',
        nav: 'rdp-nav',
        month_grid: 'rdp-month_grid',
        weekdays: 'rdp-weekdays',
        weekday: 'rdp-weekday',
        week: 'rdp-week',
        day: 'rdp-day',
        day_button: 'rdp-day_button',
        selected: 'rdp-selected',
        today: 'rdp-today',
        outside: 'rdp-outside',
        disabled: 'rdp-disabled',
        hidden: 'rdp-hidden',
        ...classNames,
      }}
      {...props}
    />
  );
}
Calendar.displayName = 'Calendar';

export { Calendar };
